import styled, { css } from 'styled-components';
import { colorTokens, fontTokens } from '../../../tokens/globals/tokens';

/* @internal */
export const SpreadsheetTableWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  transition-delay: ${({ theme }) => (theme.sliderOpen ? '300ms' : '0ms')};
  z-index: 161;
  grid-column: 1;
  grid-row: ${({ theme }) => (theme.hasMenu ? 2 : 1)};

  .read-only {
    background-color: ${colorTokens.GlobalBrandGray30};
    color: ${colorTokens.GlobalFontHierarchyBodyDefault};
    pointer-events: none;
  }

  // These properties override font settings introduced by Handsontable 10.0.0
  // They ensure there are no visual changes after the version update
  .handsontable {
    font-family: ${fontTokens.GlobalFamilyBase};
    font-size: ${fontTokens.GlobalSizeBody3};
    font-weight: ${fontTokens.GlobalWeightBody3};
  }

  // This ensures overscrolling on the horizontal axis won't trigger browser
  // to navigate back or forward in history. Additional context:
  // https://github.com/handsontable/handsontable/issues/9272#issuecomment-1106334819
  // https://github.com/handsontable/handsontable/pull/9407/files#diff-867abf4af3aa85b5d998d75e72151071cccfa72dd8aed71ee566967975f71744R230
  // Now that the propery has cross-browser support, this solution is superior, given
  // users are still able to scroll back/forward outside the spreadsheet.
  .ht_master .wtHolder {
    overscroll-behavior-x: contain;
  }

  // Force invalid border to appear on the top
  // of cells in the first row
  tr:first-child .invalid-cell {
    border-top: 2px solid ${colorTokens.GlobalBrandRed70};
  }

  // Force dropdown caret to appear on top of no word wrap cell content
  .htNoWrap .htAutocompleteArrow {
    position: relative;
    z-index: 1;
    text-overflow: ellipsis;
  }

  // Ensures autocomplete cells with no word wrap use ellipses to ensure optimal legibility for the dropdown caret
  .htNoWrap.htAutocomplete {
    text-overflow: ellipsis;
  }

  .invalid-cell {
    position: relative;
    background-color: ${colorTokens.GlobalBrandWhite} !important;
    border: 2px solid ${colorTokens.GlobalBrandRed70};

    // Force invalid border to appear on the left
    // of cells in the first column
    &:nth-child(2) {
      border-left: 2px solid ${colorTokens.GlobalBrandRed70};
    }

    &[data-error]:hover {
      overflow: visible;
    }

    &:hover::after {
      background-color: ${colorTokens.GlobalBrandRed70};
      border-radius: 3px;
      color: ${colorTokens.GlobalBrandWhite};
      content: attr(data-error);
      font-size: 13px;
      font-weight: ${fontTokens.GlobalWeightBody3};
      min-width: 160px;
      padding: 4px 6px 6px;
      line-height: 1.4;
      position: absolute;
      top: -2px;
      text-align: left;
      white-space: normal;
      z-index: 121;
    }

    &.error-tooltip__bottom {
      &:hover::after {
        top: 100%;
        transform: translateY(-100%);
      }
    }

    &.error-tooltip__left {
      &:hover::after {
        right: 100%;
      }
    }

    &.error-tooltip__right {
      &:hover::after {
        left: 100%;
      }
    }
  }

  ${({ theme }) =>
    theme.hasFixedColumns &&
    css`
      .ht_clone_left .invalid-cell:hover::after {
        left: -2px;
        right: -2px;
        top: 100%;
      }
    `};
`;
